import { environment } from 'src/environments/environment';

export function track(type, payload) {
    if (!window) {window = (window as any).track('init', environment.tracking_id_teko); }
    (window as any).track(type, payload);
}
